import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
export var DESCENDING_SORT_DIR = 'Descending';
export var ASCENDING_SORT_DIR = 'Ascending';
export var DEFAULT_SORT_COLUMN = 0 /* Date */;
/**
 * Gets the SortBy that supports Pin
 */
export function getSortBySupportingPin() {
    return {
        sortColumn: 0 /* Date */,
        sortDirection: DESCENDING_SORT_DIR,
    };
}
/**
 * Gets the list of supported sort columns
 * @param tableView for which to return the sort columns
 */
export function getSupportedSortColumns(tableView) {
    var folderId = tableView.tableQuery.folderId;
    var isSentOrDraftsFolder = folderNameToId('sentitems') == folderId || folderNameToId('drafts') == folderId;
    if (isSentOrDraftsFolder) {
        return [0 /* Date */, 2 /* Size */];
    }
    else {
        return [0 /* Date */, 1 /* From */, 2 /* Size */];
    }
}
/**
 * Gets the default sortDirection for the given sortColumn
 * @param sortColumn sortColumn for which to get the default sort direction
 * @returns the sortDirection
 */
export function getDefaulSortDirectionForSortColumn(sortColumn) {
    switch (sortColumn) {
        case 0 /* Date */:
        case 2 /* Size */:
            return DESCENDING_SORT_DIR;
        case 1 /* From */:
            return ASCENDING_SORT_DIR;
        default:
            throw new Error('getDefaulSortDirectionForSortColumn: sortColumn not supported');
    }
}
/**
 * Gets the default sortBy property
 * @returns returns the default sortBy property
 */
export function getDefaultSortBy() {
    return {
        sortColumn: DEFAULT_SORT_COLUMN,
        sortDirection: getDefaulSortDirectionForSortColumn(DEFAULT_SORT_COLUMN),
    };
}
/**
 * Gets a flag indicating whether the given tableQuery is multi-value sorted
 * @param tableQuery tableQuery to check if multi-value sorted
 * @return flag indicating whether the given tableQuery is multi-value sorted
 */
export function isTableMultiValueSort(tableQuery) {
    var tableSortColumn = tableQuery.type == 0 /* Folder */ &&
        tableQuery.sortBy.sortColumn;
    return (tableSortColumn &&
        tableQuery.listViewType == 0 /* Conversation */ &&
        tableSortColumn == 1 /* From */);
}
//# sourceMappingURL=mailSortHelper.js.map